import { Component, OnInit, ViewChild } from '@angular/core';
import {GTopicService } from './g-topic.service'
import { GeneralComponent } from './g.component';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NgModel, NgForm } from '@angular/forms';

/** Needed to add the optional functions */
export interface GeneralTeacherComponent extends GeneralComponent{

  generate?();
}

export abstract class GeneralTeacherComponent extends GeneralComponent{


  @ViewChild('definitionForm', {static: true}) public definitionForm: NgForm;
  
  protected configuration: any;
  title:string;
  description:string;
  id:number;
  protected typespecs: any;
  public type:string;
  examId:number = -1;


  constructor(protected topicService: GTopicService, protected activatedRoute: ActivatedRoute) {
    super(topicService); 
  }

  /**
   * performs some inititalizations
   */
  ngOnInit(){
    this.topicService.registerTeacherExerise(this);
    if (this.activatedRoute.snapshot.paramMap.has('examid')) {
      this.examId = +this.activatedRoute.snapshot.paramMap.get('examid');
    }
    if (this.activatedRoute.snapshot.paramMap.has('id')) {
      this.id = +this.activatedRoute.snapshot.paramMap.get('id');
      this.setInformationWithConfiguration();
    }
  }

  /** adds the configuration to the exercises */
  saveExercise(){
    let definition = this.generateDefinition();
    this.topicService.addExercise(definition);

  }

  /** adds the given configuration at the right place, depending whther this is an exercise, an exam or a question */
  add(){
    let definition = this.generateDefinition();
    if(this.type =="exam"){
      this.topicService.addExam(definition);
    } else if (this.examId > -1) {
      this.topicService.addQuestion(this.examId, definition);
    } else {
      this.topicService.addExercise(definition);
    }
  }

  /** updates the definition of this exercise or exercise set */
  update(){
    let definition = this.generateDefinition();
    if(this.type =="exam"){
      this.topicService.updateExam(definition);
    } else if (this.examId > -1) {
      this.topicService.updateQuestion(this.examId, definition);
    } else {
      this.topicService.updateExercise(definition);
    }
    this.topicService.resetStateByKey(definition.key);
  }

  abstract generateDefinition();

  /** sets the properties based on the given configuration */
  setInformationWithConfiguration(){
    this.configuration = this.topicService.getExerciseById(this.examId, this.id);
    this.title = this.configuration.title;
    this.description = this.configuration.description;
  }

  /** resets the properties to a new exercise */
  reset(){
    //this.definitionForm.reset();
    this.title = "";
    this.description ="";
    this.id=undefined;
    this.configuration = undefined;
    this.typespecs = undefined;
  }

  /** checks whether the exercise or exercise set is a self-check */
  isExam():boolean{
    return this.topicService.isExam(this.examId);
  }

  /** checks whether the exercise is in an exrecise set */
  inExerciseSet(){
    return this.examId > -1;
  }

  /** returns the topic key */
  chapterType():string{
    return this.topicService.type;
  }

}
